import { initHandlers } from './globalErrorHandler';

export const initGlobalErrorHandlers = initHandlers
